import $ from 'jquery';

// Smooth scroll
var headerHeight = $('.c-header').outerHeight();
$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('.js-toggle-tab').not('.js-open-content-popup').on('click', function(event) {
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname ) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: headerHeight === undefined ? target.offset().top : target.offset().top - headerHeight
			}, 1000);
		}
	}
});

// Initial smooth scroll
if (
	window.location.hash &&
	window.location.hash.substring(0,2) === '#!' &&
	window.location.hash.indexOf('action=') === -1
) {
	var $initialTarget = $('#' + window.location.hash.replace('#!', ''));
	if ($initialTarget.length > 0) {
		$('html, body').animate({ scrollTop: $initialTarget.offset().top - $('.c-header').height() }, 1000);
	}
}
